import '../scss/Orders.scss';
import React, { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/free-mode';
import { FreeMode } from 'swiper/modules';
import Order from './Order';
import api from '../../api';

const MyOrders = () => {
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const response = await api.get('/api/orders/UserOrdersTake', {
          params: { take: 10 }
        });
        setOrders(response.data);
      } catch (error) {
        console.error('Ошибка при загрузке заказов:', error);
      }
    };

    fetchOrders();
  }, []);

  if (orders.length === 0) return null; // или заглушка, если нужно

  if (orders.length === 1) {
    return <Order order={orders[0]} />;
  }

  return (
    <Swiper
      modules={[FreeMode]}
      spaceBetween={10}
      slidesPerView="auto"
      freeMode={true}
    >
      {orders.map((order) => (
        <SwiperSlide key={order.id} style={{ width: '90%' }}>
          <Order order={order} />
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default MyOrders;
